"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.ERC721A__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string"
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [],
        name: "ApprovalCallerNotOwnerNorApproved",
        type: "error"
    },
    {
        inputs: [],
        name: "ApprovalQueryForNonexistentToken",
        type: "error"
    },
    {
        inputs: [],
        name: "BalanceQueryForZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "MintERC2309QuantityExceedsLimit",
        type: "error"
    },
    {
        inputs: [],
        name: "MintToZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "MintZeroQuantity",
        type: "error"
    },
    {
        inputs: [],
        name: "OwnerQueryForNonexistentToken",
        type: "error"
    },
    {
        inputs: [],
        name: "OwnershipNotInitializedForExtraData",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferCallerNotOwnerNorApproved",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferFromIncorrectOwner",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferToNonERC721ReceiverImplementer",
        type: "error"
    },
    {
        inputs: [],
        name: "TransferToZeroAddress",
        type: "error"
    },
    {
        inputs: [],
        name: "URIQueryForNonexistentToken",
        type: "error"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "ApprovalForAll",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "fromTokenId",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "toTokenId",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
        ],
        name: "ConsecutiveTransfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "Transfer",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes"
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool"
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4"
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address"
            },
            {
                internalType: "address",
                name: "to",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256"
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var ERC721A__factory = /** @class */ (function (_super) {
    __extends(ERC721A__factory, _super);
    function ERC721A__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    ERC721A__factory.prototype.deploy = function (name_, symbol_, overrides) {
        return _super.prototype.deploy.call(this, name_, symbol_, overrides || {});
    };
    ERC721A__factory.prototype.getDeployTransaction = function (name_, symbol_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name_, symbol_, overrides || {});
    };
    ERC721A__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ERC721A__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ERC721A__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    ERC721A__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    ERC721A__factory.bytecode = _bytecode;
    ERC721A__factory.abi = _abi;
    return ERC721A__factory;
}(ethers_1.ContractFactory));
exports.ERC721A__factory = ERC721A__factory;
